/**
 * Login Form
 * 
 * @module component-login-form
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'component-login-form';

if (!customElements.get(customElements.component)) {

    class componentLoginForm extends HTMLElement {

        constructor() {

            super();

            this.addBtnForgotPasswordBehavior();
        }

        /**
         * Listen forgot password button
         * 
         * @return {undefined}
         */
        addBtnForgotPasswordBehavior() {
            let btn = this.querySelector('[data-recover-password-btn]');
            if (!btn) {
                return;
            }
            btn.addEventListener("click", this.showRecoverPasswordForm.bind(this));
        }

        /**
         * Show recover password form
         * 
         * @return {undefined}
         */
        showRecoverPasswordForm() {
            let recoverForm = this.querySelector('[data-recover-password-form]');
            let loginForm = this.querySelector('[data-customer-login-form]')
            if (!recoverForm) {
                return;
            }

            recoverForm.classList.add('active');
            loginForm.classList.remove('active');
        }
    }

    customElements.define(customElements.component, componentLoginForm);
}